export const CATEGORIES_TRANSLATE = {
    categories: {
        breadcrumbName: "Categories",
        messages: {
            create: "Category added successfully",
            update: "Category updated successfully",
            delete: "Category deactivated successfully",
            recover: "Category restored successfully"
        },
        list: {
            table: {
                columns: {
                    id: "ID",
                    name: "Name",
                    complaintType: "Complaint Channel"
                }
            },
            filters: {
                fields: {
                    id: {
                        label: "ID",
                        placeholder: "Enter the ID",
                        url: "id"
                    },
                    name: {
                        label: "Name",
                        placeholder: "Enter the name",
                        url: "name"
                    },
                    email: {
                        label: "Email",
                        placeholder: "Enter the email",
                        url: "email"
                    },
                    complaintType: {
                        label: "Complaint Channel",
                        placeholder: "Select the complaint channel",
                        url: "complaint-channel"
                    },
                    active: {
                        label: "Status",
                        placeholder: "Select the status",
                        url: "status"
                    }
                }
            },
            dialog: {
                delete: {
                    title: "Deactivate Category",
                    body: "Are you sure you want to deactivate the category with ID {{id}}",
                    save: {
                        text: "Yes, deactivate"
                    },
                    back: {
                        text: "Back"
                    },
                }
            }
        },
        save: {
            form: {
                fields: {
                    name: {
                        label: "Name",
                        placeholder: "Enter the name"
                    },
                    complaintType: {
                        label: "Complaint Channel",
                        placeholder: "Select the complaint channel"
                    },
                }
            }
        },
        dictionaries: {
            breadcrumb: "Dictionaries",
            messages: {
                create: "Dictionary created successfully",
                update: "Dictionary updated successfully",
                delete: "Dictionary removed successfully",
                recover: "Dictionary restored successfully"
            },
            list: {
                table: {
                    columns: {
                        id: "ID",
                        language: "Language",
                        name: "Name"
                    }
                },
                dialog: {
                    delete: {
                        title: "Remove dictionary",
                        body: "Are you sure you want to remove the dictionary with ID {{id}}?",
                        save: {
                            text: "Yes, remove"
                        },
                        back: {
                            text: "Back"
                        }
                    }
                }
            },
            save: {
                form: {
                    fields: {
                        languageId: {
                            label: "Language",
                            placeholder: "Select the language"
                        },
                        name: {
                            label: "Name",
                            placeholder: "Enter the name"
                        }
                    }
                }
            }
        }
    }
}
